import React from 'react';
import { Icon } from './Icon.js';
export const IconInvoiceCrypto = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M20 2L4 2L4 22L5.28516 22L8.5 20L11.7148 22L12.2852 22L15.5 20L18.713 22L20 22L20 2Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M16 11L12.5 15H11.5L8 11L11.5 7H12.5L16 11Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconInvoiceCrypto.js.map